import gql from "graphql-tag";

export const ADD_RESOURCES_ON_MATERIAL_DATAS = gql`
  mutation addResourcesOnMaterialDatas($where: AddResourceOnMaterialDatasInput!) {
    addResourcesOnMaterialDatas(where: $where)
  }
`;